import firebase from 'firebase/app'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyAh6GODSC-jFzKXpa89lw6887aY8w3RC2Q",
    authDomain: "liquor-industry.firebaseapp.com",
    projectId: "liquor-industry"
};

firebase.initializeApp(config);